"use client";
import { MoonStar, Sun } from "lucide-react";
import { useState } from "react";
import { cn } from "../../lib/utils";

const ThemeButton = () => {
  const [isDark, setIsDark] = useState(false);

  const toggleHander = () => {
    setIsDark((p) => !p);
    document.body.classList.toggle("dark");
  };

  return (
    <div
      className={cn(
        "rounded-l-md fixed bg-black backdrop-blur-sm shadow-md w-8 h-8 flex justify-center items-center top-1 right-1 cursor-pointer group duration-300 z-40",
        "hover:bg-white dark:hover:bg-blue-500"
      )}
      onClick={toggleHander}
    >
      {isDark ? (
        <Sun
          className="text-blue-500/90 group-hover:text-white group-hover:scale-105 duration-300"
          size={20}
          strokeWidth={2}
        />
      ) : (
        <MoonStar
          className="text-white/90 group-hover:scale-105 duration-300"
          size={20}
          strokeWidth={2}
        />
      )}
    </div>
  );
};

export default ThemeButton;
